/**
 * Alarm Types store
 * @module store/alarm-types
 */


import { createStore, createHook } from '@thermon-platforms/react-sweet-state';
import api from 'util/api';
import { uniqBy } from 'lodash';

// define store initial state
const initialState = {
  types: [],
  loading: false,
  error: undefined,
  updated: undefined
};
// define the actions that mutate the state
export const actions = {
  query: () => async ({ getState, setState }) => {
    const now = Date.now();
    const currentState = getState();
    // If we're already loading alarms or the current data is still fresh, return
    if (currentState.loading || (now - currentState.updated) < (60 * 1000)) return;
    setState({ loading: true });
    try {
      // Fetch our data
      const res = await api('/alarms/types');
      // and unwrap it
      // NOTE - uniqBy here to filter dupes. This shouldn't be necessary.
      const types = uniqBy(await res.json(), 'id').filter(type => type.name != 'None');

      setState({ types, loading: false,  updated: Date.now() });
    } catch (error) {
      console.error(error);
      // If that fails, update our state with the error
      setState({ error, loading: false, updated: Date.now() });
    }
  }
}

// create a store type
const Store = createStore({ initialState, actions });

// create components to access store state instances
const useStore = createHook(Store);

/**
 * Expose hooks for store
 * @function useStore
 * @memberof module:store/alarm-types
 * @example
 * const [alarmTypesStore, alarmTypesStoreActions] = useAlarmTypesStore();
 */
export default useStore;
